/* eslint-disable array-callback-return */
/* eslint-disable react/destructuring-assignment */
import { Dangers } from './dangers';
import { Header } from './header';
import { ItemContext, ReportContext } from './hooks/use-context';
import { InitialInfos } from './initial-infos';
import { Pictures } from './pictures';
import { Providences } from './providences';
import { Table } from './table';
import type { EventReportData } from './types';

export function GoiasaIncidentAnalysis(props: { reportData: EventReportData }) {
  return (
    <ReportContext value={props.reportData}>
      <div style={{ breakAfter: 'page' }}>
        {props.reportData.body.items.map((item) => (
          <ItemContext value={item}>
            <div
              style={{
                height: '90%',
                width: '100vw',
                flex: 1,
                backgroundColor: 'white',
                fontFamily: 'sans-serif',
              }}
            >
              <div
                style={{
                  margin: '1rem auto',
                  height: 'auto',
                  maxWidth: '64rem',
                  pageBreakAfter: 'always',
                }}
              >
                <Header sectionName="Análise de Ocorrências" />
                <div
                  style={{
                    height: '100%',
                    width: '100%',
                    backgroundColor: '#fff',
                  }}
                >
                  <InitialInfos />
                  <Dangers />
                  <Pictures />
                </div>
              </div>
              <div
                style={{
                  margin: '1rem auto',
                  height: 'auto',
                  maxWidth: '64rem',
                }}
              >
                <Header sectionName="Análise de Acidentes" />
                <div
                  style={{
                    height: '100%',
                    width: '100%',
                    backgroundColor: '#fff',
                  }}
                >
                  <Table />
                  <Providences />
                </div>
              </div>
            </div>
          </ItemContext>
        ))}
      </div>
    </ReportContext>
  );
}
